export const BUCKET_OBJECTS_UPLOAD_START = 'BUCKET_OBJECTS_UPLOAD_START';
export function actionUploadStart() {
    return {
        type: BUCKET_OBJECTS_UPLOAD_START,
    };
}

export const BUCKET_OBJECTS_UPLOAD_CANCEL = 'BUCKET_OBJECTS_UPLOAD_CANCEL';
export function actionUploadCancel() {
    return {
        type: BUCKET_OBJECTS_UPLOAD_CANCEL,
    };
}

export const BUCKET_OBJECTS_UPLOAD_CHANGE_ACL =
    'BUCKET_OBJECTS_UPLOAD_CHANGE_ACL';
export function actionUploadChangeAcl({ ACL }) {
    return {
        type: BUCKET_OBJECTS_UPLOAD_CHANGE_ACL,
        data: { ACL },
    };
}
